import { useEffect, useState } from 'react';

import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';

/**
 * FHSG-348: Returns the loyalty `offersLoading` flag with a trailing settle window.
 *
 * - `offersLoading` true → returns true.
 * - `offersLoading` flips true → false → keeps returning true and starts a timer.
 * - If `offersLoading` flips back to true during the timer → timer is reset.
 * - When the timer expires while `offersLoading` is still false → returns false.
 *
 * This absorbs the back-to-back evaluation cycle that fires when an eval result
 * updates `offersEligibleItems` → `calculatedCartTotal` → debounced re-eval.
 */
export function useOffersLoadingWithTrailingSettle(settleMs = 500) {
  const offersLoading = useAppSelector(selectors.loyalty.selectOffersLoading);
  const [keepLoading, setKeepLoading] = useState(offersLoading);

  useEffect(() => {
    if (offersLoading) {
      setKeepLoading(true);
      return undefined;
    }

    const timer = setTimeout(() => {
      setKeepLoading(false);
    }, settleMs);

    return () => {
      clearTimeout(timer);
    };
  }, [offersLoading, settleMs]);

  return offersLoading || keepLoading;
}
